import findOptionNameById from 'src/compass/shared/util/findOptionNameById';
import { filterLabel } from './renderFilter';

// Helpers for CasTable's advanced-filters drawer + chips.

// A filter is "active" when its value would narrow results. Object-shaped values
// (e.g. a date range) are active when any of their parts is set — checked without
// whitelisting key names so new range-ish shapes work unchanged.
export const isFilterActive = (value: any): boolean => {
  if (value == null || value === '') return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object')
    return Object.values(value).some((v) => v != null && v !== '');
  return true;
};

// The value that clears a filter. Arrays clear to [] (the shape the multi-select
// and the backend's Count > 0 guard expect); everything else clears to null, which
// every Cas filter control treats as empty.
export const emptyFilterValue = (value: any): any => (Array.isArray(value) ? [] : null);

// Chip text for one applied filter. Multi-selects show a count (their option names
// live inside the component, not here); single selects resolve id -> name when the
// filter carries an options array.
export const filterChipLabel = (filter: any, value: any): string => {
  const label = filterLabel(filter);
  if (Array.isArray(value)) return `${label}: ${value.length} selected`;
  if (typeof value === 'boolean') return `${label}: ${value ? 'Yes' : 'No'}`;
  if (value && typeof value === 'object') return `${label}: range`;
  if (Array.isArray(filter.options)) {
    const name = findOptionNameById({
      id: value,
      options: filter.options,
      optionsIdField: filter.optionsIdField,
      optionsNameField: filter.optionsNameField,
    });
    if (name) return `${label}: ${name}`;
  }
  return `${label}: ${value}`;
};
